/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  CubeInfo,
  FaultWithStateInfo,
  HorizonWithStateInfo,
  NameInfo,
  ProjectHorizonResponseWithState,
  SurveyProfileInfo,
} from './data-contracts'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ProjectSeismicClient<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags ProjectSeismic
   * @summary Получение проектных горизонтов с интерпретацией по заданному кубу и горизонтов без интерпретаций
   * @request GET:/bff/ProjectSeismic/project/{projectId}/horizon/withInterpretation/cube/{cubeId}
   * @secure
   */
  projectSeismicGetByProjectAndCubeId = (
    projectId: string,
    cubeId: string,
    params: RequestParams = {},
  ) =>
    this.http.request<ProjectHorizonResponseWithState[], any>({
      path: `/bff/ProjectSeismic/project/${projectId}/horizon/withInterpretation/cube/${cubeId}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectSeismic
   * @summary Получение проектных горизонтов с интерпретацией по заданной 2д съемке и горизонтов без интерпретаций
   * @request GET:/bff/ProjectSeismic/project/{projectId}/horizon/withInterpretation/survey2d/{surveyId}
   * @secure
   */
  projectSeismicGetByProjectAndSurvey2DId = (
    projectId: string,
    surveyId: string,
    params: RequestParams = {},
  ) =>
    this.http.request<ProjectHorizonResponseWithState[], any>({
      path: `/bff/ProjectSeismic/project/${projectId}/horizon/withInterpretation/survey2d/${surveyId}`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectSeismic
   * @summary Получение проектных горизонтов
   * @request GET:/bff/ProjectSeismic/project/{projectId}/horizon
   * @secure
   */
  projectSeismicGetHorizonsByProjectId = (projectId: string, params: RequestParams = {}) =>
    this.http.request<HorizonWithStateInfo[], any>({
      path: `/bff/ProjectSeismic/project/${projectId}/horizon`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectSeismic
   * @summary Получение проектных кубов
   * @request GET:/bff/ProjectSeismic/project/{projectId}/cube
   * @secure
   */
  projectSeismicGetCubesByProjectId = (projectId: string, params: RequestParams = {}) =>
    this.http.request<CubeInfo[], any>({
      path: `/bff/ProjectSeismic/project/${projectId}/cube`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectSeismic
   * @summary Получение проектных разломов
   * @request GET:/bff/ProjectSeismic/project/{projectId}/fault
   * @secure
   */
  projectSeismicGetFaultsByProjectId = (projectId: string, params: RequestParams = {}) =>
    this.http.request<FaultWithStateInfo[], any>({
      path: `/bff/ProjectSeismic/project/${projectId}/fault`,
      method: 'GET',
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectSeismic
   * @summary Переименование драфтового сейсмического объекта
   * @request PUT:/bff/ProjectSeismic/project/{projectId}/renameObject
   * @secure
   */
  projectSeismicRenameObject = (projectId: string, data: NameInfo, params: RequestParams = {}) =>
    this.http.request<boolean, any>({
      path: `/bff/ProjectSeismic/project/${projectId}/renameObject`,
      method: 'PUT',
      body: data,
      secure: true,
      type: ContentType.Json,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectSeismic
   * @summary Получить одинаковые кубы проекта
   * @request GET:/bff/ProjectSeismic/project/{projectId}/sameCubes
   * @secure
   */
  projectSeismicGetSameProjectCubes = (
    projectId: string,
    query: {
      /**
       * Идентификатор куба
       * @format uuid
       */
      cubeId: string
    },
    params: RequestParams = {},
  ) =>
    this.http.request<CubeInfo[], any>({
      path: `/bff/ProjectSeismic/project/${projectId}/sameCubes`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    }) /**
   * No description
   *
   * @tags ProjectSeismic
   * @summary Получить одинаковые профили 2D съемок проекта
   * @request GET:/bff/ProjectSeismic/project/{projectId}/sameSurveys2dProfiles
   * @secure
   */
  projectSeismicGetSameProjectSurveys2DProfiles = (
    projectId: string,
    query: {
      /**
       * Идентификатор профиля 2D съемки
       * @format uuid
       */
      profileId: string
    },
    params: RequestParams = {},
  ) =>
    this.http.request<SurveyProfileInfo[], any>({
      path: `/bff/ProjectSeismic/project/${projectId}/sameSurveys2dProfiles`,
      method: 'GET',
      query: query,
      secure: true,
      format: 'json',
      ...params,
    })
}
